import React, { useContext } from "react";

import {
	AchDepositBlock,
	EbtBlock,
	FeeMainBlock,
	FeeSecondaryBlock,
	GatewayBlock,
	MiscFees,
} from "./blocks";
import FeesTemplateContext from "../feesTemplateContext";

import styles from "./feesAdditional.module.scss";

const Divider = () => <hr className="line" />;
const Header = ({ value }) => <div className={styles.header}>{value}</div>;

const FeesAdditionalFields = ({ form, isMerchantFeesPage, formValues }) => {
	const {
		validators,
		isMerchant,
		isEditApplication,
		isFiservFspProcessor,
		application: { isPaperApplication },
	} = useContext(FeesTemplateContext);

	return (
		<>
			<Header value="Additional Fees" />
			<FeeMainBlock
				validators={validators}
				isMerchant={isMerchant}
				isEditApplication={isEditApplication}
				isFiservFspProcessor={isFiservFspProcessor}
				formName={form}
				isMerchantFeesPage={isMerchantFeesPage}
				isPaperApplication={isPaperApplication}
			/>
			<Divider />
			<FeeSecondaryBlock
				validators={validators}
				isPaperApplication={isPaperApplication}
			/>
			<Divider />
			<Header value="First Data Payeezy Merchant Pricing SM Gateway" />
			<GatewayBlock
				isMerchant={isMerchant}
				isFiservFspProcessor={isFiservFspProcessor}
				validators={validators}
				isPaperApplication={isPaperApplication}
			/>
			<Divider />
			<Header value="EBT / Cash Benefits" />
			<EbtBlock
				validators={validators}
				isPaperApplication={isPaperApplication}
				formValues={formValues}
			/>
			<Divider />
			<MiscFees
				form={form}
				validators={validators}
				isPaperApplication={isPaperApplication}
			/>
			<Divider />
			<Header value="ACH Deposit" />
			<AchDepositBlock />
		</>
	);
};

export default FeesAdditionalFields;
